"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const events_1 = __importDefault(require("events"));
const data_service_1 = __importDefault(require("./services/data-service"));
const api_service_1 = __importDefault(require("./services/api-service"));
const socket_service_1 = __importDefault(require("./services/socket-service"));
const new_asset_1 = __importDefault(require("./models/new-asset"));
const new_gateway_1 = __importDefault(require("./models/new-gateway"));
const new_site_1 = __importDefault(require("./models/new-site"));
const new_order_1 = __importDefault(require("./models/new-order"));
const new_session_1 = __importDefault(require("./models/new-session"));
const new_stripeSession_1 = __importDefault(require("./models/new-stripeSession"));
const new_stripeWebhook_1 = __importDefault(require("./models/new-stripeWebhook"));
const new_zapierWebhook_1 = __importDefault(require("./models/new-zapierWebhook"));
const new_modbusModel_1 = __importDefault(require("./models/new-modbusModel"));
const new_occupancySchedule_1 = __importDefault(require("./models/new-occupancySchedule"));
const new_pubOrg_1 = __importDefault(require("./models/new-pubOrg"));
const new_paymentCard_1 = __importDefault(require("./models/new-paymentCard"));
const new_rule_1 = __importDefault(require("./models/new-rule"));
const new_dataRequest_1 = __importDefault(require("./models/new-dataRequest"));
const new_dataRequestLink_1 = __importDefault(require("./models/new-dataRequestLink"));
const new_invoiceRequest_1 = __importDefault(require("./models/new-invoiceRequest"));
const new_invoiceRequestLink_1 = __importDefault(require("./models/new-invoiceRequestLink"));
const new_siteGroup_1 = __importDefault(require("./models/new-siteGroup"));
const new_group_1 = __importDefault(require("./models/new-group"));
const new_customFieldType_1 = __importDefault(require("./models/new-customFieldType"));
const new_customField_1 = __importDefault(require("./models/new-customField"));
const new_location_1 = __importDefault(require("./models/new-location"));
const new_searchHistory_1 = __importDefault(require("./models/new-searchHistory"));
const new_tariff_1 = __importDefault(require("./models/new-tariff"));
const new_groupType_1 = __importDefault(require("./models/new-groupType"));
const new_calculatorInbound_1 = __importDefault(require("./models/new-calculatorInbound"));
const new_calculatorResult_1 = __importDefault(require("./models/new-calculatorResult"));
const new_createReport_1 = __importDefault(require("./models/new-createReport"));
const new_report_1 = __importDefault(require("./models/new-report"));
const new_gaiaMessage_1 = __importDefault(require("./models/new-gaiaMessage"));
const new_dataCategory_1 = __importDefault(require("./models/new-dataCategory"));
const new_dataType_1 = __importDefault(require("./models/new-dataType"));
const new_deviceCategory_1 = __importDefault(require("./models/new-deviceCategory"));
const new_widgetBoard_1 = __importDefault(require("./models/new-widgetBoard"));
const new_reportFileLink_1 = __importDefault(require("./models/new-reportFileLink"));
const new_audit_1 = __importDefault(require("./models/new-audit"));
const new_application_1 = __importDefault(require("./models/new-application"));
const new_dcRetryPayment_1 = __importDefault(require("./models/new-dcRetryPayment"));
const new_resetSecret_1 = __importDefault(require("./models/new-resetSecret"));
const new_requestSecret_1 = __importDefault(require("./models/new-requestSecret"));
const new_assetIdentification_1 = __importDefault(require("./models/new-assetIdentification"));
const new_getPhaseBreakdown_1 = __importDefault(require("./models/new-getPhaseBreakdown"));
const new_physicalGateway_1 = __importDefault(require("./models/new-physicalGateway"));
const new_sitePermission_1 = __importDefault(require("./models/new-sitePermission"));
const new_dataUpload_1 = __importDefault(require("./models/new-dataUpload"));
const new_file_1 = __importDefault(require("./models/new-file"));
const new_zip_1 = __importDefault(require("./models/new-zip"));
const new_confirmOrgInvite_1 = __importDefault(require("./models/new-confirmOrgInvite"));
const new_dcCreateAccount_1 = __importDefault(require("./models/new-dcCreateAccount"));
const new_dcSession_1 = __importDefault(require("./models/new-dcSession"));
const new_paymentSheet_1 = __importDefault(require("./models/new-paymentSheet"));
const new_organisationInvite_1 = __importDefault(require("./models/new-organisationInvite"));
const new_resetToken_1 = __importDefault(require("./models/new-resetToken"));
const new_password_1 = __importDefault(require("./models/new-password"));
const new_thirdPartyIntegration_1 = __importDefault(require("./models/new-thirdPartyIntegration"));
const new_orgPartner_1 = __importDefault(require("./models/new-orgPartner"));
const new_mfaSecret_1 = __importDefault(require("./models/new-mfaSecret"));
const new_mfaVerification_1 = __importDefault(require("./models/new-mfaVerification"));
const new_mfaAuthentication_1 = __importDefault(require("./models/new-mfaAuthentication"));
const new_loginAs_1 = __importDefault(require("./models/new-loginAs"));
const new_loginAsPartner_1 = __importDefault(require("./models/new-loginAsPartner"));
const new_gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require("./models/new-gatewayTrustedDeviceUntrustRequest"));
const new_aggregateTelemetryGroupRequest_1 = __importDefault(require("./models/new-aggregateTelemetryGroupRequest"));
const new_assetRemoveDataRequest_1 = __importDefault(require("./models/new-assetRemoveDataRequest"));
const new_assetAggregateDataRequest_1 = __importDefault(require("./models/new-assetAggregateDataRequest"));
const new_gatewayTrustedDeviceAnalysis_1 = __importDefault(require("./models/new-gatewayTrustedDeviceAnalysis"));
const new_aggregateTelemetry_1 = __importDefault(require("./models/new-aggregateTelemetry"));
const new_instantaneousTelemetry_1 = __importDefault(require("./models/new-instantaneousTelemetry"));
const new_gatewayLogDownloadRequest_1 = __importDefault(require("./models/new-gatewayLogDownloadRequest"));
const new_gatewayEnhancedLogDownloadRequest_1 = __importDefault(require("./models/new-gatewayEnhancedLogDownloadRequest"));
const new_gatewayGod_1 = __importDefault(require("./models/new-gatewayGod"));
const new_assetGod_1 = __importDefault(require("./models/new-assetGod"));
const new_assetReset_1 = __importDefault(require("./models/new-assetReset"));
const new_inspiredLogin_1 = __importDefault(require("./models/new-inspiredLogin"));
const new_dataUnit_1 = __importDefault(require("./models/new-dataUnit"));
class Gridduck extends events_1.default.EventEmitter {
    constructor() {
        super();
        this._config = { apiKey: '', apiSecret: '', type: '', scopes: [] };
        this.apiService = new api_service_1.default(this._config);
        this.dataService = new data_service_1.default(this.apiService, this);
        this.socketService = new socket_service_1.default(this.dataService, this.apiService);
    }
    set config(value) {
        this._config = value;
        this.apiService.config = value;
    }
    get config() {
        return this._config;
    }
    get userId() {
        if (this._config && this._config.accessToken && this._config.accessToken.user) {
            return this._config.accessToken.user.id;
        }
        return null;
    }
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiService.login(username, password);
        });
    }
    logout() {
        return this.apiService.logout();
    }
    abortAllRequests(reason) {
        this.apiService.cancel(reason);
    }
    submitMFA(mfaString) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiService.submitMFA(mfaString);
        });
    }
    getAccessToken() {
        return this._config.accessToken;
    }
    setAccessToken(accessToken) {
        this._config.accessToken = accessToken;
        this.apiService.config = this._config;
        return this.apiService.checkAccessToken();
    }
    onLoggedOut(callback) {
        this.apiService.onLoggedOut(callback);
    }
    onLostConnection(callback) {
        this.apiService.onLostConnection(callback);
    }
    onOpenConnectionCallback(callback) {
        this.apiService.onOpenConnectionCallback(callback);
    }
    deleteAccessToken() {
        this._config.accessToken = undefined;
        this.apiService.config = this._config;
    }
    getAssets(params) {
        return this.dataService.getAssets(params);
    }
    getAsset(params) {
        return this.dataService.getAsset(params);
    }
    createAsset(newItem) {
        return this.dataService.createAsset(new new_asset_1.default(newItem));
    }
    getGateways(params) {
        return this.dataService.getGateways(params);
    }
    getGateway(params) {
        return this.dataService.getGateway(params);
    }
    createGateway(newItem) {
        return this.dataService.createGateway(new new_gateway_1.default(newItem));
    }
    getGatewaySoftwareVersions(params) {
        return this.dataService.getGatewaySoftwareVersions(params);
    }
    getGatewaySoftwareVersion(params) {
        return this.dataService.getGatewaySoftwareVersion(params);
    }
    getSites(params) {
        return this.dataService.getSites(params);
    }
    getSite(params) {
        return this.dataService.getSite(params);
    }
    createSite(newItem) {
        return this.dataService.createSite(new new_site_1.default(newItem));
    }
    getOrders(params) {
        return this.dataService.getOrders(params);
    }
    createOrder(newItem) {
        return this.dataService.createOrder(new new_order_1.default(newItem));
    }
    getSessions(params) {
        return this.dataService.getSessions(params);
    }
    getSession(params) {
        return this.dataService.getSession(params);
    }
    createSession(newItem) {
        return this.dataService.createSession(new new_session_1.default(newItem));
    }
    getDiscounts(params) {
        return this.dataService.getDiscounts(params);
    }
    createStripeSession(newItem) {
        return this.dataService.createStripeSession(new new_stripeSession_1.default(newItem));
    }
    createStripeWebhook(newItem) {
        return this.dataService.createStripeWebhook(new new_stripeWebhook_1.default(newItem));
    }
    createZapierWebhook(newItem) {
        return this.dataService.createZapierWebhook(new new_zapierWebhook_1.default(newItem));
    }
    getPlacess(params) {
        return this.dataService.getPlacess(params);
    }
    getPlaces(params) {
        return this.dataService.getPlaces(params);
    }
    getProducts(params) {
        return this.dataService.getProducts(params);
    }
    getModbusModels(params) {
        return this.dataService.getModbusModels(params);
    }
    getModbusModel(params) {
        return this.dataService.getModbusModel(params);
    }
    createModbusModel(newItem) {
        return this.dataService.createModbusModel(new new_modbusModel_1.default(newItem));
    }
    getOccupancySchedules(params) {
        return this.dataService.getOccupancySchedules(params);
    }
    getOccupancySchedule(params) {
        return this.dataService.getOccupancySchedule(params);
    }
    createOccupancySchedule(newItem) {
        return this.dataService.createOccupancySchedule(new new_occupancySchedule_1.default(newItem));
    }
    createPubOrg(newItem) {
        return this.dataService.createPubOrg(new new_pubOrg_1.default(newItem));
    }
    getOrganisation(params) {
        return this.dataService.getOrganisation(params);
    }
    getPaymentCards(params) {
        return this.dataService.getPaymentCards(params);
    }
    getPaymentCard(params) {
        return this.dataService.getPaymentCard(params);
    }
    createPaymentCard(newItem) {
        return this.dataService.createPaymentCard(new new_paymentCard_1.default(newItem));
    }
    getAssetEvents(params) {
        return this.dataService.getAssetEvents(params);
    }
    getGatewayEvents(params) {
        return this.dataService.getGatewayEvents(params);
    }
    getAssetTelemetrys(params) {
        return this.dataService.getAssetTelemetrys(params);
    }
    getRules(params) {
        return this.dataService.getRules(params);
    }
    getRule(params) {
        return this.dataService.getRule(params);
    }
    createRule(newItem) {
        return this.dataService.createRule(new new_rule_1.default(newItem));
    }
    getDataRequests(params) {
        return this.dataService.getDataRequests(params);
    }
    getDataRequest(params) {
        return this.dataService.getDataRequest(params);
    }
    createDataRequest(newItem) {
        return this.dataService.createDataRequest(new new_dataRequest_1.default(newItem));
    }
    createDataRequestLink(newItem) {
        return this.dataService.createDataRequestLink(new new_dataRequestLink_1.default(newItem));
    }
    getInvoiceRequests(params) {
        return this.dataService.getInvoiceRequests(params);
    }
    getInvoiceRequest(params) {
        return this.dataService.getInvoiceRequest(params);
    }
    createInvoiceRequest(newItem) {
        return this.dataService.createInvoiceRequest(new new_invoiceRequest_1.default(newItem));
    }
    createInvoiceRequestLink(newItem) {
        return this.dataService.createInvoiceRequestLink(new new_invoiceRequestLink_1.default(newItem));
    }
    getSiteGroups(params) {
        return this.dataService.getSiteGroups(params);
    }
    getSiteGroup(params) {
        return this.dataService.getSiteGroup(params);
    }
    createSiteGroup(newItem) {
        return this.dataService.createSiteGroup(new new_siteGroup_1.default(newItem));
    }
    getGroups(params) {
        return this.dataService.getGroups(params);
    }
    getGroup(params) {
        return this.dataService.getGroup(params);
    }
    createGroup(newItem) {
        return this.dataService.createGroup(new new_group_1.default(newItem));
    }
    getDuckChargeAdmins(params) {
        return this.dataService.getDuckChargeAdmins(params);
    }
    getCustomFieldTypes(params) {
        return this.dataService.getCustomFieldTypes(params);
    }
    createCustomFieldType(newItem) {
        return this.dataService.createCustomFieldType(new new_customFieldType_1.default(newItem));
    }
    getCustomFields(params) {
        return this.dataService.getCustomFields(params);
    }
    createCustomField(newItem) {
        return this.dataService.createCustomField(new new_customField_1.default(newItem));
    }
    getLocations(params) {
        return this.dataService.getLocations(params);
    }
    createLocation(newItem) {
        return this.dataService.createLocation(new new_location_1.default(newItem));
    }
    getSearchHistorys(params) {
        return this.dataService.getSearchHistorys(params);
    }
    createSearchHistory(newItem) {
        return this.dataService.createSearchHistory(new new_searchHistory_1.default(newItem));
    }
    getTariffs(params) {
        return this.dataService.getTariffs(params);
    }
    getTariff(params) {
        return this.dataService.getTariff(params);
    }
    createTariff(newItem) {
        return this.dataService.createTariff(new new_tariff_1.default(newItem));
    }
    getGroupTypes(params) {
        return this.dataService.getGroupTypes(params);
    }
    createGroupType(newItem) {
        return this.dataService.createGroupType(new new_groupType_1.default(newItem));
    }
    createCalculatorInbound(newItem) {
        return this.dataService.createCalculatorInbound(new new_calculatorInbound_1.default(newItem));
    }
    createCalculatorResult(newItem) {
        return this.dataService.createCalculatorResult(new new_calculatorResult_1.default(newItem));
    }
    createCreateReport(newItem) {
        return this.dataService.createCreateReport(new new_createReport_1.default(newItem));
    }
    getReportHistorys(params) {
        return this.dataService.getReportHistorys(params);
    }
    getReports(params) {
        return this.dataService.getReports(params);
    }
    getReport(params) {
        return this.dataService.getReport(params);
    }
    createReport(newItem) {
        return this.dataService.createReport(new new_report_1.default(newItem));
    }
    getReportFiles(params) {
        return this.dataService.getReportFiles(params);
    }
    getGaiaConversations(params) {
        return this.dataService.getGaiaConversations(params);
    }
    getGaiaConversation(params) {
        return this.dataService.getGaiaConversation(params);
    }
    getGaiaMessages(params) {
        return this.dataService.getGaiaMessages(params);
    }
    createGaiaMessage(newItem) {
        return this.dataService.createGaiaMessage(new new_gaiaMessage_1.default(newItem));
    }
    getDataCategorys(params) {
        return this.dataService.getDataCategorys(params);
    }
    getDataCategory(params) {
        return this.dataService.getDataCategory(params);
    }
    createDataCategory(newItem) {
        return this.dataService.createDataCategory(new new_dataCategory_1.default(newItem));
    }
    getDataTypes(params) {
        return this.dataService.getDataTypes(params);
    }
    getDataType(params) {
        return this.dataService.getDataType(params);
    }
    createDataType(newItem) {
        return this.dataService.createDataType(new new_dataType_1.default(newItem));
    }
    getDeviceCategorys(params) {
        return this.dataService.getDeviceCategorys(params);
    }
    createDeviceCategory(newItem) {
        return this.dataService.createDeviceCategory(new new_deviceCategory_1.default(newItem));
    }
    getWidgetBoard(params) {
        return this.dataService.getWidgetBoard(params);
    }
    createWidgetBoard(newItem) {
        return this.dataService.createWidgetBoard(new new_widgetBoard_1.default(newItem));
    }
    createReportFileLink(newItem) {
        return this.dataService.createReportFileLink(new new_reportFileLink_1.default(newItem));
    }
    getRuleEvents(params) {
        return this.dataService.getRuleEvents(params);
    }
    getAudits(params) {
        return this.dataService.getAudits(params);
    }
    getAudit(params) {
        return this.dataService.getAudit(params);
    }
    createAudit(newItem) {
        return this.dataService.createAudit(new new_audit_1.default(newItem));
    }
    getApplications(params) {
        return this.dataService.getApplications(params);
    }
    getApplication(params) {
        return this.dataService.getApplication(params);
    }
    createApplication(newItem) {
        return this.dataService.createApplication(new new_application_1.default(newItem));
    }
    getAnomalyModels(params) {
        return this.dataService.getAnomalyModels(params);
    }
    getAnomalyModel(params) {
        return this.dataService.getAnomalyModel(params);
    }
    getAnomalys(params) {
        return this.dataService.getAnomalys(params);
    }
    getAnomaly(params) {
        return this.dataService.getAnomaly(params);
    }
    getGridduckSubscriptions(params) {
        return this.dataService.getGridduckSubscriptions(params);
    }
    getGridduckInvoices(params) {
        return this.dataService.getGridduckInvoices(params);
    }
    getAccounts(params) {
        return this.dataService.getAccounts(params);
    }
    getAccount(params) {
        return this.dataService.getAccount(params);
    }
    getCustomFieldDatas(params) {
        return this.dataService.getCustomFieldDatas(params);
    }
    getPreferences(params) {
        return this.dataService.getPreferences(params);
    }
    createDcRetryPayment(newItem) {
        return this.dataService.createDcRetryPayment(new new_dcRetryPayment_1.default(newItem));
    }
    getIssues(params) {
        return this.dataService.getIssues(params);
    }
    getIgnoredDevices(params) {
        return this.dataService.getIgnoredDevices(params);
    }
    createResetSecret(newItem) {
        return this.dataService.createResetSecret(new new_resetSecret_1.default(newItem));
    }
    createRequestSecret(newItem) {
        return this.dataService.createRequestSecret(new new_requestSecret_1.default(newItem));
    }
    createAssetIdentification(newItem) {
        return this.dataService.createAssetIdentification(new new_assetIdentification_1.default(newItem));
    }
    createGetPhaseBreakdown(newItem) {
        return this.dataService.createGetPhaseBreakdown(new new_getPhaseBreakdown_1.default(newItem));
    }
    getAvailableGateways(params) {
        return this.dataService.getAvailableGateways(params);
    }
    getAssetDemands(params) {
        return this.dataService.getAssetDemands(params);
    }
    getAssetConsumptions(params) {
        return this.dataService.getAssetConsumptions(params);
    }
    getPhysicalGateway(params) {
        return this.dataService.getPhysicalGateway(params);
    }
    createPhysicalGateway(newItem) {
        return this.dataService.createPhysicalGateway(new new_physicalGateway_1.default(newItem));
    }
    getSitePermissions(params) {
        return this.dataService.getSitePermissions(params);
    }
    createSitePermission(newItem) {
        return this.dataService.createSitePermission(new new_sitePermission_1.default(newItem));
    }
    getApplianceCategorys(params) {
        return this.dataService.getApplianceCategorys(params);
    }
    getApplianceTypes(params) {
        return this.dataService.getApplianceTypes(params);
    }
    getDataUploads(params) {
        return this.dataService.getDataUploads(params);
    }
    getDataUpload(params) {
        return this.dataService.getDataUpload(params);
    }
    createDataUpload(newItem, onUploadProgress) {
        return this.dataService.createDataUpload(new new_dataUpload_1.default(newItem), onUploadProgress);
    }
    getFiles(params) {
        return this.dataService.getFiles(params);
    }
    createFile(newItem, onUploadProgress) {
        return this.dataService.createFile(new new_file_1.default(newItem), onUploadProgress);
    }
    createZip(newItem) {
        return this.dataService.createZip(new new_zip_1.default(newItem));
    }
    getSearchs(params) {
        return this.dataService.getSearchs(params);
    }
    getVerifyOrgInvite(params) {
        return this.dataService.getVerifyOrgInvite(params);
    }
    createConfirmOrgInvite(newItem) {
        return this.dataService.createConfirmOrgInvite(new new_confirmOrgInvite_1.default(newItem));
    }
    createDcCreateAccount(newItem) {
        return this.dataService.createDcCreateAccount(new new_dcCreateAccount_1.default(newItem));
    }
    getDcSessions(params) {
        return this.dataService.getDcSessions(params);
    }
    getDcSession(params) {
        return this.dataService.getDcSession(params);
    }
    createDcSession(newItem) {
        return this.dataService.createDcSession(new new_dcSession_1.default(newItem));
    }
    createPaymentSheet(newItem) {
        return this.dataService.createPaymentSheet(new new_paymentSheet_1.default(newItem));
    }
    getDcChargePoint(params) {
        return this.dataService.getDcChargePoint(params);
    }
    getDcChargeStations(params) {
        return this.dataService.getDcChargeStations(params);
    }
    getOrganisationInvites(params) {
        return this.dataService.getOrganisationInvites(params);
    }
    createOrganisationInvite(newItem) {
        return this.dataService.createOrganisationInvite(new new_organisationInvite_1.default(newItem));
    }
    getOrganisationMembers(params) {
        return this.dataService.getOrganisationMembers(params);
    }
    getDetectedDevices(params) {
        return this.dataService.getDetectedDevices(params);
    }
    getResetToken(params) {
        return this.dataService.getResetToken(params);
    }
    createResetToken(newItem) {
        return this.dataService.createResetToken(new new_resetToken_1.default(newItem));
    }
    createPassword(newItem) {
        return this.dataService.createPassword(new new_password_1.default(newItem));
    }
    getThirdPartyIntegrations(params) {
        return this.dataService.getThirdPartyIntegrations(params);
    }
    createThirdPartyIntegration(newItem) {
        return this.dataService.createThirdPartyIntegration(new new_thirdPartyIntegration_1.default(newItem));
    }
    getOrgPartners(params) {
        return this.dataService.getOrgPartners(params);
    }
    getOrgPartner(params) {
        return this.dataService.getOrgPartner(params);
    }
    createOrgPartner(newItem) {
        return this.dataService.createOrgPartner(new new_orgPartner_1.default(newItem));
    }
    createMfaSecret(newItem) {
        return this.dataService.createMfaSecret(new new_mfaSecret_1.default(newItem));
    }
    createMfaVerification(newItem) {
        return this.dataService.createMfaVerification(new new_mfaVerification_1.default(newItem));
    }
    createMfaAuthentication(newItem) {
        return this.dataService.createMfaAuthentication(new new_mfaAuthentication_1.default(newItem));
    }
    createLoginAs(newItem) {
        return this.dataService.createLoginAs(new new_loginAs_1.default(newItem));
    }
    createLoginAsPartner(newItem) {
        return this.dataService.createLoginAsPartner(new new_loginAsPartner_1.default(newItem));
    }
    getOrganisationManagements(params) {
        return this.dataService.getOrganisationManagements(params);
    }
    getOrganisationManagement(params) {
        return this.dataService.getOrganisationManagement(params);
    }
    getStagingDatabase(params) {
        return this.dataService.getStagingDatabase(params);
    }
    getNotifications(params) {
        return this.dataService.getNotifications(params);
    }
    getZigbeeFirmwares(params) {
        return this.dataService.getZigbeeFirmwares(params);
    }
    getZigbeeFirmware(params) {
        return this.dataService.getZigbeeFirmware(params);
    }
    getGatewayTrustList(params) {
        return this.dataService.getGatewayTrustList(params);
    }
    createGatewayTrustedDeviceUntrustRequest(newItem) {
        return this.dataService.createGatewayTrustedDeviceUntrustRequest(new new_gatewayTrustedDeviceUntrustRequest_1.default(newItem));
    }
    getTelemetryOperations(params) {
        return this.dataService.getTelemetryOperations(params);
    }
    createAggregateTelemetryGroupRequest(newItem) {
        return this.dataService.createAggregateTelemetryGroupRequest(new new_aggregateTelemetryGroupRequest_1.default(newItem));
    }
    createAssetRemoveDataRequest(newItem) {
        return this.dataService.createAssetRemoveDataRequest(new new_assetRemoveDataRequest_1.default(newItem));
    }
    createAssetAggregateDataRequest(newItem) {
        return this.dataService.createAssetAggregateDataRequest(new new_assetAggregateDataRequest_1.default(newItem));
    }
    getGatewayTrustedDeviceAnalysiss(params) {
        return this.dataService.getGatewayTrustedDeviceAnalysiss(params);
    }
    getGatewayTrustedDeviceAnalysis(params) {
        return this.dataService.getGatewayTrustedDeviceAnalysis(params);
    }
    createGatewayTrustedDeviceAnalysis(newItem) {
        return this.dataService.createGatewayTrustedDeviceAnalysis(new new_gatewayTrustedDeviceAnalysis_1.default(newItem));
    }
    getAggregateTelemetrys(params) {
        return this.dataService.getAggregateTelemetrys(params);
    }
    getAggregateTelemetry(params) {
        return this.dataService.getAggregateTelemetry(params);
    }
    createAggregateTelemetry(newItem) {
        return this.dataService.createAggregateTelemetry(new new_aggregateTelemetry_1.default(newItem));
    }
    getInstantaneousTelemetrys(params) {
        return this.dataService.getInstantaneousTelemetrys(params);
    }
    getInstantaneousTelemetry(params) {
        return this.dataService.getInstantaneousTelemetry(params);
    }
    createInstantaneousTelemetry(newItem) {
        return this.dataService.createInstantaneousTelemetry(new new_instantaneousTelemetry_1.default(newItem));
    }
    getOrganisationSearchs(params) {
        return this.dataService.getOrganisationSearchs(params);
    }
    createGatewayLogDownloadRequest(newItem) {
        return this.dataService.createGatewayLogDownloadRequest(new new_gatewayLogDownloadRequest_1.default(newItem));
    }
    createGatewayEnhancedLogDownloadRequest(newItem) {
        return this.dataService.createGatewayEnhancedLogDownloadRequest(new new_gatewayEnhancedLogDownloadRequest_1.default(newItem));
    }
    getGatewayGods(params) {
        return this.dataService.getGatewayGods(params);
    }
    getGatewayGod(params) {
        return this.dataService.getGatewayGod(params);
    }
    createGatewayGod(newItem) {
        return this.dataService.createGatewayGod(new new_gatewayGod_1.default(newItem));
    }
    getAssetGods(params) {
        return this.dataService.getAssetGods(params);
    }
    getAssetGod(params) {
        return this.dataService.getAssetGod(params);
    }
    createAssetGod(newItem) {
        return this.dataService.createAssetGod(new new_assetGod_1.default(newItem));
    }
    getAssetTelemetryBatchs(params) {
        return this.dataService.getAssetTelemetryBatchs(params);
    }
    getAssetConsumptionBatchs(params) {
        return this.dataService.getAssetConsumptionBatchs(params);
    }
    getRawAggregateDatas(params) {
        return this.dataService.getRawAggregateDatas(params);
    }
    getAssetResets(params) {
        return this.dataService.getAssetResets(params);
    }
    createAssetReset(newItem) {
        return this.dataService.createAssetReset(new new_assetReset_1.default(newItem));
    }
    createInspiredLogin(newItem) {
        return this.dataService.createInspiredLogin(new new_inspiredLogin_1.default(newItem));
    }
    getDataUnits(params) {
        return this.dataService.getDataUnits(params);
    }
    getDataUnit(params) {
        return this.dataService.getDataUnit(params);
    }
    createDataUnit(newItem) {
        return this.dataService.createDataUnit(new new_dataUnit_1.default(newItem));
    }
    getItemMetadata(params) {
        return this.dataService.getItemMetadata(params);
    }
    getAvailableScopes() {
        return [
            'god',
            'asset:view',
            'asset:admin',
            'asset:edit',
            'gateway:view',
            'gateway:admin',
            'gateway:edit',
            'gateway-software-version:view',
            'gateway-software-version:edit',
            'site:view',
            'site:admin',
            'site:edit',
            'order:view',
            'order:admin',
            'session:view',
            'session:admin',
            'session:edit',
            'discount:view',
            'stripe-session:admin',
            'stripe-webhook:admin',
            'zapier-webhook:admin',
            'places:view',
            'product:view',
            'modbus-model:view',
            'modbus-model:admin',
            'modbus-model:edit',
            'occupancy-schedule:view',
            'occupancy-schedule:admin',
            'occupancy-schedule:edit',
            'pub-org:admin',
            'organisation:view',
            'organisation:edit',
            'payment-card:view',
            'payment-card:admin',
            'payment-card:edit',
            'asset-event:view',
            'gateway-event:view',
            'asset-telemetry:view',
            'rule:view',
            'rule:admin',
            'rule:edit',
            'data-request:view',
            'data-request:admin',
            'data-request-link:admin',
            'invoice-request:view',
            'invoice-request:admin',
            'invoice-request-link:admin',
            'site-group:view',
            'site-group:admin',
            'site-group:edit',
            'group:view',
            'group:admin',
            'group:edit',
            'duck-charge-admin:view',
            'custom-field-type:view',
            'custom-field-type:admin',
            'custom-field-type:edit',
            'custom-field:view',
            'custom-field:admin',
            'custom-field:edit',
            'location:view',
            'location:admin',
            'location:edit',
            'search-history:view',
            'search-history:admin',
            'tariff:view',
            'tariff:admin',
            'tariff:edit',
            'group-type:view',
            'group-type:admin',
            'group-type:edit',
            'calculator-inbound:admin',
            'calculator-result:admin',
            'create-report:admin',
            'report-history:view',
            'report:view',
            'report:admin',
            'report:edit',
            'report-file:view',
            'gaia-conversation:view',
            'gaia-conversation:admin',
            'gaia-conversation:edit',
            'gaia-message:view',
            'gaia-message:admin',
            'data-category:view',
            'data-category:admin',
            'data-category:edit',
            'data-type:view',
            'data-type:admin',
            'data-type:edit',
            'device-category:view',
            'device-category:admin',
            'device-category:edit',
            'widget-board:view',
            'widget-board:admin',
            'widget-board:edit',
            'report-file-link:admin',
            'rule-event:view',
            'audit:view',
            'audit:admin',
            'application:view',
            'application:admin',
            'anomaly-model:view',
            'anomaly:view',
            'anomaly:edit',
            'gridduck-subscription:view',
            'gridduck-invoice:view',
            'account:view',
            'account:edit',
            'custom-field-data:view',
            'preferences:view',
            'preferences:edit',
            'dc-retry-payment:admin',
            'issue:view',
            'ignored-device:view',
            'reset-secret:admin',
            'request-secret:admin',
            'asset-identification:admin',
            'get-phase-breakdown:admin',
            'available-gateway:view',
            'available-gateway:edit',
            'asset-demand:view',
            'asset-consumption:view',
            'physical-gateway:view',
            'physical-gateway:admin',
            'physical-gateway:edit',
            'site-permission:view',
            'site-permission:admin',
            'site-permission:edit',
            'appliance-category:view',
            'appliance-type:view',
            'data-upload:view',
            'data-upload:admin',
            'data-upload:edit',
            'file:view',
            'file:admin',
            'file:edit',
            'zip:admin',
            'search:view',
            'verify-org-invite:view',
            'confirm-org-invite:admin',
            'dc-create-account:admin',
            'dc-session:view',
            'dc-session:admin',
            'payment-sheet:admin',
            'dc-charge-point:view',
            'dc-charge-station:view',
            'organisation-invite:view',
            'organisation-invite:admin',
            'organisation-invite:edit',
            'organisation-member:view',
            'organisation-member:admin',
            'organisation-member:edit',
            'organisation-member-logout:admin',
            'detected-device:view',
            'detected-device:edit',
            'reset-token:view',
            'reset-token:admin',
            'reset-token:edit',
            'password:admin',
            'third-party-integration:view',
            'third-party-integration:admin',
            'org-partner:view',
            'org-partner:admin',
            'org-partner:edit',
            'mfa-secret:admin',
            'mfa-verification:admin',
            'mfa-authentication:admin',
            'login-as:admin',
            'login-as-partner:admin',
            'organisation-management:view',
            'organisation-management:edit',
            'staging-database:view',
            'staging-database:edit',
            'notification:view',
            'notification:edit',
            'zigbee-firmware:view',
            'gateway-trust-list:view',
            'gateway-trusted-device-untrust-request:admin',
            'telemetry-operation:view',
            'aggregate-telemetry-group-request:admin',
            'asset-remove-data-request:admin',
            'asset-aggregate-data-request:admin',
            'gateway-trusted-device-analysis:view',
            'gateway-trusted-device-analysis:admin',
            'gateway-trusted-device-analysis:edit',
            'aggregate-telemetry:view',
            'aggregate-telemetry:admin',
            'aggregate-telemetry:edit',
            'instantaneous-telemetry:view',
            'instantaneous-telemetry:admin',
            'instantaneous-telemetry:edit',
            'organisation-search:view',
            'gateway-log-download-request:admin',
            'gateway-enhanced-log-download-request:admin',
            'gateway-god:view',
            'gateway-god:admin',
            'gateway-god:edit',
            'asset-god:view',
            'asset-god:admin',
            'asset-god:edit',
            'asset-telemetry-batch:view',
            'asset-consumption-batch:view',
            'raw-aggregate-data:view',
            'asset-reset:view',
            'asset-reset:admin',
            'asset-reset:edit',
            'inspired-login:admin',
            'data-unit:view',
            'data-unit:admin',
            'data-unit:edit',
            'item-metadata:view',
        ];
    }
    getPublicAvailableScopes() {
        return [
            'asset:view',
            'asset:admin',
            'asset:edit',
            'gateway:view',
            'gateway:admin',
            'gateway:edit',
            'site:view',
            'site:admin',
            'site:edit',
            'modbus-model:view',
            'modbus-model:admin',
            'modbus-model:edit',
            'occupancy-schedule:view',
            'occupancy-schedule:admin',
            'occupancy-schedule:edit',
            'data-request:view',
            'data-request:admin',
            'data-request-link:admin',
            'group:view',
            'group:admin',
            'group:edit',
            'duck-charge-admin:view',
            'custom-field-type:view',
            'custom-field-type:admin',
            'custom-field-type:edit',
            'custom-field:view',
            'custom-field:admin',
            'custom-field:edit',
            'location:view',
            'location:admin',
            'location:edit',
            'search-history:view',
            'search-history:admin',
            'tariff:view',
            'tariff:admin',
            'tariff:edit',
            'group-type:view',
            'group-type:admin',
            'group-type:edit',
            'data-type:view',
            'data-type:admin',
            'data-type:edit',
            'gridduck-subscription:view',
            'gridduck-invoice:view',
            'notification:view',
            'notification:edit',
            'aggregate-telemetry:view',
            'aggregate-telemetry:admin',
            'aggregate-telemetry:edit',
            'instantaneous-telemetry:view',
            'instantaneous-telemetry:admin',
            'instantaneous-telemetry:edit',
            'data-unit:view',
            'data-unit:admin',
            'data-unit:edit',
        ];
    }
}
module.exports = new Gridduck();
//# sourceMappingURL=gridduck.js.map